<template>
  <form class="p-3" @submit.prevent="handleValidSubmit">
    <div
      class="border card-form mb-3"
      v-for="(form, index) in forms"
      :key="index"
    >
      <b-row class="p-3">
        <b-col md="12" class="d-flex justify-content-between">
          <h5 class="text-primary mb-3" style="font-weight: 500"
            >Schedule Form</h5
          >
          <div>
            <i
              v-if="index > 0"
              class="fa fa-trash text-danger"
              style="cursor: pointer"
              @click="() => deleteForm(index)"
            ></i>
          </div>
        </b-col>
        <b-col md="6">
          <b-form-group label="Fleet Name *" label-for="fleet_name">
            <v-select
              class="bg-white"
              :options="fleetsOpt"
              placeholder="Select Fleet"
              v-model="form.vehicle_id"
              label="label"
              track-by="id"
              :reduce="(option) => option.id"
            ></v-select>
            <small v-if="errors[index]?.vehicle_id" class="text-danger"
              >This field is required.</small
            >
          </b-form-group>
        </b-col>
        <b-col :md="form.maintenance_type == 'service_and_repair' ? 3 : 6">
          <b-form-group label="Maintenance Type *" label-for="maintenance_type">
            <v-select
              required
              class="bg-white"
              :options="maintenanceTypes"
              label="label"
              v-model="form.maintenance_type"
              placeholder="Select Fleet"
              :reduce="(option) => option.value"
              track-by="value"
            ></v-select>
            <small v-if="errors[index]?.maintenance_type" class="text-danger"
              >This field is required.</small
            >
          </b-form-group>
        </b-col>
        <b-col md="3" v-if="form.maintenance_type == 'service_and_repair'">
          <b-form-group
            label="Service & Repair Type *"
            label-for="maintenance_type"
          >
            <v-select
              required
              class="bg-white"
              v-model="form.task_type_id"
              :options="optionsTaskType"
              placeholder="Select Maintenance Type"
              label="label"
              :reduce="(option) => option.id"
              track-by="id"
            ></v-select>
            <small v-if="errors[index]?.task_type_id" class="text-danger"
              >This field is required.</small
            >
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group required label="Start Date *" label-for="start_date">
            <date-picker
              v-model="form.start_date"
              class="bg-white w-100"
              value-type="YYYY-MM-DD"
              type="date"
              placeholder="Select date and time"
              format="DD-MM-YYYY"
            ></date-picker>
            <small v-if="errors[index]?.start_date" class="text-danger"
              >This field is required.</small
            >
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :required="(form.status||'')==='closed'" :label="`End Date${(form.status||'')==='closed' ? ' *' : ''}`" label-for="end_date">
             <date-picker
              v-model="form.end_date"
              class="bg-white w-100"
              value-type="YYYY-MM-DD"
              type="date"
              placeholder="Select date and time"
              format="DD-MM-YYYY"
            ></date-picker>
            <small v-if="errors[index]?.end_date" class="text-danger">End Date is required when status is Closed.</small>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Remarks" label-for="end_date">
            <wysiwyg
              :style="{ height: '200px' }"
              id="remark"
              v-model="form.remark"
              class="bg-white"
            />
            <!-- <b-form-textarea id="remark" class="bg-white" v-model="form.remark"
                            placeholder="Enter remarks here" rows="3"></b-form-textarea> -->
          </b-form-group>
        </b-col>

        <!-- Log Status section -->
        <b-col md="12" class="mt-2">
          <h5 class="text-primary mb-3" style="font-weight: 600">LOG STATUS</h5>
        </b-col>
        <b-col md="4">
          <b-form-group label="Status Date *">
            <date-picker
              v-model="form.status_date"
              class="bg-white w-100"
              value-type="YYYY-MM-DD HH:mm:ss"
              type="datetime"
              placeholder="Select date"
              format="DD-MM-YYYY HH:mm:ss"
            />
            <small v-if="errors[index]?.status_date" class="text-danger">This field is required.</small>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Status *">
            <v-select
              class="bg-white"
              :options="filteredStatusOptions(form)"
              v-model="form.status"
              placeholder="Select status"
              label="label"
              :reduce="o => o.value"
              track-by="value"
            />
            <small v-if="errors[index]?.status" class="text-danger">This field is required.</small>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Create By *">
            <v-select
              class="bg-white"
              :options="creatorOptions"
              v-model="form.user_id"
              placeholder="Select creator"
              label="label"
              :reduce="o => o.value"
              track-by="value"
            />
            <small v-if="errors[index]?.user_id" class="text-danger">This field is required.</small>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-table-lite :items="logStatusList" :fields="logStatusFields" small responsive>
            <template #cell(date)="{ item }">{{ formatDate(item.status_date) }}</template>
            <template #cell(total_day)="{ item }">{{ calcTotalDays(item.status_date, item) }}</template>
            <template #cell(status)="{ item }">{{ item.status }}</template>
            <template #cell(created_by)="{ item }">{{ item.user.detail.name }}</template>
          </b-table-lite>
        </b-col>
      </b-row>
    </div>
    <div class="d-flex justify-content-end mt-3">
      <b-button
        class="mt-3 mr-2"
        size="sm"
        variant="outline-primary"
        type="button"
        @click="$emit('close')"
        >Cancel</b-button
      >
      <b-button
        v-if="!selectedData"
        class="mt-3 mr-2"
        size="sm"
        variant="outline-primary"
        type="button"
        @click="addForm"
        >Add Form</b-button
      >
      <b-button
        class="mt-3"
        size="sm"
        variant="primary"
        type="submit"
        :loading="loading"
        >Submit</b-button
      >
    </div>
  </form>
</template>
<script>
import moment from '@/node_modules/moment/moment'
import { fleetsActions, srActions, usersActions } from '@/src/Utils/helper'

export default {
  name: 'FormTargetFleetAvailability',
  props: {
    showForm: Boolean,
    optionsTaskType: {
      type: Array,
      default: () => [],
    },
    selectedData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      forms: [
        {
          vehicle_id: '',
          start_date: '',
          end_date: '',
          remark: '',
          maintenance_type: '',
          task_type_id: null,
          status: '',
          user_id: '',
          status_date: moment().format('YYYY-MM-DD HH:mm:ss')
        },
      ],
      errors: [],
      form: {
        vehicle_id: '',
        start_date: '',
        end_date: '',
        remark: '',
        maintenance_type: '',
        task_type_id: null,
        status: '',
        user_id: '',
        status_date: new Date()
      },
      fleetsOpt: [],
      maintenanceTypes: [
        {
          label: 'Docking',
          value: 'docking',
        },
        {
          label: 'Service & Repair',
          value: 'service_and_repair',
        },
      ],
      loading: false,
      user_id: JSON.parse(localStorage.getItem('profile')).id,

      // Log Status state
      logStatus: {
        date: '',
        status: null,
        created_by: null,
      },
      statusOptions: [
        { label: 'Open', value: 'open' },
        { label: 'On Progress', value: 'on progress' },
        { label: 'Closed', value: 'closed' },
      ],
      creatorOptions: [],
      logStatusFields: [
        { key: 'date', label: 'Date' },
        { key: 'total_day', label: 'Total Day' },
        { key: 'status', label: 'Status' },
        { key: 'created_by', label: 'Create By' },
      ],
      logStatusList: [],
    }
  },
  methods: {
    ...fleetsActions,
    ...srActions,
    ...usersActions,
    filteredStatusOptions(form){
      // When end_date is filled, show only 'closed'; otherwise show all
      const hasEnd = !!form?.end_date
      return hasEnd ? this.statusOptions.filter(o => o.value === 'closed') : this.statusOptions
    },
    async fetchFleets() {
      try {
        this.fleets = []
        let params = this.$options.filters.cleanObject({
          page: 1,
          perPage: 9999,
          showAll: false,
          active: true,
          search: ''
        })
        let res = await this.getFleets(params)
        this.fleetsOpt = res.data.map((el) => {
          return {
            id: el.id,
            label: el.name,
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async fetchUsersForCreator () {
      try {
        const params = this.$options.filters.cleanObject({
          page: 1,
          perPage: 9999,
          search: '',
          active: true
        })
        const res = await this.getUsers(params)
        this.creatorOptions = res.data.data.map(u => ({ label: u.userDetail?.name, value: u.id }))
        // Preselect current user if available
        const profile = JSON.parse(localStorage.getItem('profile'))
        if (profile?.name) this.logStatus.created_by = profile.name
      } catch (e) {
        this.creatorOptions = []
      }
    },
    async handleSubmit() {
      try {
        this.loading = true
        const target_availabilities = this.forms.map((el) => {
          return {
            vehicle_id: el.vehicle_id,
            start_date: moment(el.start_date).format('YYYY-MM-DD HH:mm:ss'),
            end_date: el.end_date ? moment(el.end_date).format('YYYY-MM-DD HH:mm:ss') : null,
            remark: el.remark,
            maintenance_type: el.maintenance_type,
            task_type_id: el.task_type_id,
            status: el.status,
            created_by: el.user_id,
            user_id: el.user_id,
            status_date: moment(el.status_date).format('YYYY-MM-DD HH:mm:ss')
          }
        })
        let data = null
        if (this.selectedData) {
          data = target_availabilities[0]
        } else {
          data = { target_availabilities }
        }
        const apiMethod = this.selectedData
          ? this.updateTargetAvailability({ data, id: this.selectedData?.id })
          : this.createTargetAvailabilities({ data })
        const res = await apiMethod
        this.$swal({
          title: 'Success',
          text: res.message,
          icon: 'success',
        })
        this.$emit('refetch')
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Error!',
          type: 'error',
          text: error?.response?.data?.message || 'Failed Create / Update Data!',
          icon: 'error',
        })
      } finally {
        this.loading = false
      }
    },
    handleChangeInput(value) {
      if (this.form.is_same_input) {
      }
    },
    handleReset() {
      this.form.vehicle_type_ids = []
      this.form.year = moment().toDate()
      this.form.remark = ''
      this.$emit('refetch')
    },
    addForm() {
      this.forms.push({
        ...this.form,
      })
    },
    deleteForm(index) {
      this.forms.splice(index, 1)
    },
    handleValidSubmit() {
      this.forms.map((el, index) => {
        for (const key in el) {
          if (key !== 'remark') {
            if (key == 'task_type_id') {
              if (!el[key] && el.maintenance_type == 'service_and_repair') {
                this.$set(this.errors, index, {
                  ...this.errors[index],
                  [key]: true,
                })
              } else {
                this.$set(this.errors, index, {
                  ...this.errors[index],
                  [key]: false,
                })
              }
            } else {
              // Dynamic validation for end_date based on status
              if (key === 'end_date') {
                const mustHaveEndDate = (el.status === 'closed')
                if (mustHaveEndDate && !el.end_date) {
                  this.$set(this.errors, index, {
                    ...this.errors[index],
                    end_date: true,
                  })
                } else {
                  this.$set(this.errors, index, {
                    ...this.errors[index],
                    end_date: false,
                  })
                }
              } else if (['status_date','status','user_id','vehicle_id','start_date','maintenance_type'].includes(key)) {
                if (!el[key]) {
                  this.$set(this.errors, index, {
                    ...this.errors[index],
                    [key]: true,
                  })
                } else {
                  this.$set(this.errors, index, {
                    ...this.errors[index],
                    [key]: false,
                  })
                }
              } else if (!el[key]) {
                this.$set(this.errors, index, {
                  ...this.errors[index],
                  [key]: true,
                })
              } else {
                this.$set(this.errors, index, {
                  ...this.errors[index],
                  [key]: false,
                })
              }
            }
          }
        }
      })
      if (this.errors.some((el) => Object.values(el).some((val) => val))) {
        this.$swal({
          title: 'Error!',
          type: 'warning',
          text: 'Please fill all required fields!',
          icon: 'error',
        })
      } else {
        this.handleSubmit()
      }
    },
    formatDate(val){
      if(!val) return '-'
      return moment(val).format('DD/MM/YYYY HH:mm')
    },
    calcTotalDays(statusDate, item) {
      if (!statusDate) return '-'
      const index = this.logStatusList.indexOf(item)
      const current = moment(statusDate, [
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD',
        moment.ISO_8601,
        'DD/MM/YYYY',
        'DD-MM-YYYY'
      ], true)
      if (!current.isValid()) return '-'

      // Pair each row with the next row only
      const nextRow = this.logStatusList[index + 1]
      if (!nextRow || !nextRow.status_date) return '0 Day 0 Hour 0 Min'
      const nextMoment = moment(nextRow.status_date, [
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD',
        moment.ISO_8601,
        'DD/MM/YYYY',
        'DD-MM-YYYY'
      ], true)
      if (!nextMoment.isValid()) return '0 Day 0 Hour 0 Min'

      // We want duration from current (row i) to the next row (row i+1).
      // If list is sorted descending by createdAt, next row is earlier.
      // Use absolute positive diff of (current - next)
      const start = nextMoment
      const end = current

      const diffMs = Math.max(0, end.diff(start))
      const totalMinutes = Math.floor(diffMs / (60 * 1000))
      const days = Math.floor(totalMinutes / (24 * 60))
      const hours = Math.floor((totalMinutes % (24 * 60)) / 60)
      const minutes = totalMinutes % 60

      return `${days} Day ${hours} Hour ${minutes} Min`
    },
  },
  watch: {
    // Auto-set status to 'closed' when end_date is filled
    forms: {
      handler(newForms) {
        newForms.forEach((f) => {
          if (f && f.end_date && f.status !== 'closed') {
            f.status = 'closed'
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchFleets()
    this.fetchUsersForCreator()
    if (this.selectedData) {
      this.forms = [
        {
          vehicle_id: this.selectedData.vehicle_id,
          start_date: moment(this.selectedData.start_date).format("YYYY-MM-DD HH:mm:ss"),
          end_date: this.selectedData.end_date ? moment(this.selectedData.end_date).format('YYYY-MM-DD HH:mm:ss') : null,
          remark: this.selectedData.remark,
          maintenance_type: this.selectedData.maintenance_type,
          task_type_id: this.selectedData.task_type_id,
          status_date: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      ]
      this.logStatusList = this.selectedData.status_logs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    }
  },
}
</script>
<style scoped>
.card-form {
  background: #f7f7f7;
  border-radius: 10px;
}

.overflow-auto {
  overflow: auto !important;
}

.relative {
  position: relative;
}

.col-month {
  min-width: 160px;
}

.sticky {
  position: sticky !important;
}

.col-1 {
  left: 0px !important;
  z-index: 20;
  min-width: 40px;
}

.col-2 {
  left: 40px !important;
  z-index: 20;
  min-width: 200px;
  max-width: 200px;
}

.col-3 {
  left: 240px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}

.col-4 {
  left: 340px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}

.col-5 {
  left: 440px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
</style>
